var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-indicator"},[_c('div',{staticClass:"step-indicator tabs-section d-flex"},_vm._l((_vm.steps),function(item,index){return _c('div',{key:index,staticClass:"tab",class:{
        active: _vm.step === item.number,
        unblocked: !_vm.isTabsBlocked,
        disabled: !_vm.stepIsAvailable(item.number)
      },on:{"click":function($event){return _vm.changeStep(item.number)}}},[_c('span',{staticClass:"tab__name"},[_vm._v(_vm._s(item.name))]),_c('span',{staticClass:"tab__description"},[_vm._v(_vm._s(item.description))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }